export const getFullLabelTitle = label => {
  if (!label) return '';
  if (!label.parent_label) return label.title;
  return `${label.parent_label.title}/${label.title}`;
};
